import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalFooterComponent } from '@base/components/private/modals/modal-footer/modal-footer.component';
import { ModalHeaderComponent } from '@base/components/private/modals/modal-header/modal-header.component';
import { ModalBodyComponent } from '@base/components/private/modals/modal-body/modal-body.component';
import { TranslatePipe } from '@base/pipes/private/translate.pipe';
import { ModalService } from '@base/services/private/modal.service';
import { ThemeService } from '@base/services/private/theme.service';
import { GlobalService } from '@base/services/private/global.service';
import { Subscription } from 'rxjs';

// local enum for active button states
enum ActiveButton {
  CANCEL_VIDEO_MEETING = 'cancel-video-meeting',
}

@Component({
  selector: 'app-modal-cancel-video-meeting',
  imports: [ModalFooterComponent, ModalHeaderComponent, ModalBodyComponent, TranslatePipe],
  templateUrl: './modal-cancel-video-meeting.component.html',
  styleUrl: './modal-cancel-video-meeting.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalCancelVideoMeetingComponent implements OnInit, OnDestroy {
  private readonly modalSrv = inject(ModalService);
  private readonly themeSrv = inject(ThemeService);
  private readonly globalSrv = inject(GlobalService);

  @Input() modalId = '';

  activeButton = '';
  isHttpRequestRunning = false;
  isBgDarkMode = this.themeSrv.isBgDarkMode;

  ActiveButton = ActiveButton;
  httpRequestObserver$: Subscription | null = null;

  ngOnInit(): void {
    this.listenHttpRequestState();
  }

  ngOnDestroy(): void {
    this.httpRequestObserver$?.unsubscribe();
    this.globalSrv.destroyModalRef(this.modalId);
  }

  /**
   * close modal
   */
  close(): void {
    this.modalSrv.close();
  }

  /**
   * Listens for HTTP request state changes and updates the component state accordingly.
   * @returns void
   */
  listenHttpRequestState(): void {
    this.httpRequestObserver$ = this.globalSrv.httpRequestObserver().subscribe({
      next: (res) => {
        this.isHttpRequestRunning = res;
      },
    });
  }

  /**
   * cancel video meeting
   */
  cancelVideoMeeting(): void {
    this.activeButton = ActiveButton.CANCEL_VIDEO_MEETING;

    this.globalSrv.setHttpRequestState(true);
    setTimeout(() => {
      this.activeButton = '';
      this.globalSrv.setHttpRequestState(false);
      this.modalSrv.close(this.modalId, {
        key: 'CANCEL_VIDEO_MEETING',
        value: {
          deleted: true,
        },
      });
    }, 300);
  }
}
